import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Col, Form, Button } from 'react-bootstrap';

const Request2 = () => {
  const location = useLocation();
  const isInvestigaciones = location.pathname === '/investigaciones';
  
  const [message, setMessage] = useState(''); 

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "5ff21f7e-afe1-4a26-9b37-4836b52afcfd");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: json
      });

      const result = await res.json();

      if (result.success) {
        event.target.reset();
        setMessage('¡El correo fue enviado!');
      } else {
        setMessage('Algo salió mal. Por favor, inténtalo de nuevo.');
      }
    } catch (error) {
      console.error("Request failed", error);
      setMessage('Error al enviar el correo. Inténtalo más tarde.');
    }
  };

  const phoneNumberAd = '541150520070'; 
  const messageWP = 'Hola ARMAT03, estoy interesado en sus servicios de seguridad. Me gustaría que me contacten!';

  const phoneNumberET = '541131422279'; 
  const phoneNumberIN = '541128441659'; 

  const WhatsAppAd = ({phone, message}) => {
    const link = `https://api.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(messageWP)}`;
    return <Button variant="btn" className='text-white' href={link}><WPIcon/>+54 9 11 5052 0070</Button>;
  }

  const WhatsAppET = ({phone, message }) => {
    const link = `https://api.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(messageWP)}`;
    return <Button variant="btn" className='text-white' href={link}><WPIcon/>+54 9 11 3142 2279</Button>;
  }

  const WhatsAppIN = ({phone, message }) => {
    const link = `https://api.whatsapp.com/send/?phone=${phone}&text=${encodeURIComponent(messageWP)}`;
    return <Button variant="btn" className='text-white btn-investigaciones-text' href={link}><WPIconInv />+54 9 11 2844 1659</Button>;
  }

  const WPIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 24 24" className='icono-wp-white'>
      <path d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z"></path>
    </svg>
  );

  const WPIconInv = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64" height="64" viewBox="0 0 24 24" className='icono-wp-white-inv'>
      <path d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z"></path>
    </svg>
  );

  return (
    <div style={{ backgroundColor: '#13361C', padding: '40px' }}>
      <Row className="text-white" >
        <Col md={4} className="mt-1 mb-4">
          <h4 className='titulo-linea mb-4'><b>CONTÁCTANOS</b></h4>

          <div className="d-flex align-items-start gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#8CFFBE" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-map-pin flex-shrink-0"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" /><path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0" /></svg>
            <div>
              <h5 className="text-white fw-bold mb-1">Estamos en:</h5>
              <h6 className="text-white fw-normal mb-0" style={{ lineHeight: 1.5, fontSize: '18px' }}>
                Fragata Argentina 2063,<br />
                Pilar – Bs.As., Argentina
              </h6>
            </div>
          </div>
        
          <br />

          <div className="d-flex align-items-start gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#8CFFBE" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-mail"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10" /><path d="M3 7l9 6l9 -6" /></svg>
            <div>
              <h5 className="text-white fw-bold mb-1">Email: </h5>
              <h6 className="text-white fw-normal mb-0" style={{ lineHeight: 1.5, fontSize: '18px' }}>
                info@armatseguridad.com
              </h6>
            </div>
          </div>

          <br />


          <div className="d-flex align-items-start gap-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#8CFFBE" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-phone"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" /></svg>
            <div>
              <h5 className="text-white fw-bold mb-1">Teléfono: </h5>
              <h6 className="text-white fw-normal mb-0" style={{ lineHeight: 1.5, fontSize: '23px' }}>
                (011) 5052-0070
              </h6>
            </div>
          </div>

        </Col>
        <Col md={8} className="">        
          <h3 className="titulo-linea mb-3"><b>PEDÍ TU COTIZACIÓN</b></h3>

          <Form onSubmit={onSubmit}>
            <Row className="mb-3">
              <Col>
                <Form.Control
                  type="text"
                  placeholder="Nombre"
                  name="name" 
                  required
                />
              </Col>
              <Col>
                <Form.Control
                  type="email"
                  placeholder="Correo Electrónico"
                  name="email" 
                  required
                />
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Control
                type="tel"
                placeholder="Teléfono"
                name="phone" 
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Motivo de Contacto"
                name="request" 
                required
              />
            </Form.Group>
            <div className='d-flex justify-content-center'>
              <Button type="submit" variant="btn btn-lg" className="btn-orange" style={{width:"100%"}}>
                <b className='text-white'>ENVIAR CONSULTA</b>
              </Button>
            </div>
            
          </Form>
          <div >
            <hr className="my-4" />
          </div>
          <div className="d-flex align-items-center justify-content-between flex-wrap">
              <p className="text-white mb-0" style={{ fontSize: '30px'}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 24 24" fill="none" stroke="#8CFFBE" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-briefcase me-2" style={{ verticalAlign: '-0.2em' }}><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 9a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -9" /><path d="M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2" /><path d="M12 12l0 .01" /><path d="M3 13a20 20 0 0 0 18 0" /></svg>
                ¿Querés formar parte de nuestro equipo?
              </p>
              <Button
                variant="outline-success"
                size="lg"
                className="m-0 px-5 py-3"
                style={{ minWidth: '340px', borderWidth: '2px' }}
                href={`mailto:cv.rrhh@armatseguridad.com?subject=${encodeURIComponent('Envío de CV')}`}
              >
                <b className="text-white">ENVIÁ TU CV</b>
              </Button>
            </div>
          {message && (
            <p style={{ color: 'white', marginTop: '10px' }}>{message}</p>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Request2;
